module.exports = __webpack_public_path__ + "static/home-simcrestapp-graphic-6788c15bce38c8ec3afe49cb70ab0899.svg";